export const MAP_ID = 'map';
export const FLY_DURATION = 1000;
